import { initMap, initView } from '@/services/map-services/map-service';
import '@/services/map-services/ol-map-extensions';
export var MapMutationCodes;
(function (MapMutationCodes) {
    MapMutationCodes["ADD_LAYER_TO_CATALOG"] = "ADD_LAYER_TO_CATALOG";
    MapMutationCodes["REMOVE_LAYER_FROM_CATALOG"] = "REMOVE_LAYER_FROM_CATALOG";
    MapMutationCodes["SET_SIDETRAY_ACTIVE"] = "SET_SIDETRAY_ACTIVE";
    MapMutationCodes["SET_SIDETRAY_TITLE"] = "SET_SIDETRAY_TITLE";
    MapMutationCodes["SET_BOTTOM_DRAWER_ACTIVE"] = "SET_BOTTOM_DRAWER_ACTIVE";
    MapMutationCodes["SET_BOTTOM_DRAWER_TITLE"] = "SET_BOTTOM_DRAWER_TITLE";
    MapMutationCodes["SELECT_BASEMAP"] = "SELECT_BASEMAP";
    MapMutationCodes["SET_MAP_OBJECT"] = "SET_MAP_OBJECT";
    MapMutationCodes["UPDATE_MAP_TARGET"] = "UPDATE_MAP_TARGET";
    MapMutationCodes["ADD_MAP_LAYER"] = "ADD_MAP_LAYER";
})(MapMutationCodes || (MapMutationCodes = {}));
export const mutations = {
    [MapMutationCodes.ADD_LAYER_TO_CATALOG](state, payload) {
        payload.drawOrder = state.layers.length + 1;
        payload.visible = true;
        payload.opacity = 1;
        state.layers.push(payload);
    },
    [MapMutationCodes.REMOVE_LAYER_FROM_CATALOG](state, payload) {
        // @ts-ignore
        state.ol.map?.RemoveLayerById(payload.id);
        const index = state.layers.indexOf(payload, 0);
        if (index > -1) {
            state.layers.splice(index, 1);
        }
    },
    [MapMutationCodes.SET_SIDETRAY_ACTIVE](state, payload) {
        state.sidetray.active = payload;
    },
    [MapMutationCodes.SET_SIDETRAY_TITLE](state, payload) {
        state.sidetray.title = payload;
    },
    [MapMutationCodes.SET_BOTTOM_DRAWER_ACTIVE](state, payload) {
        state.bottomDrawer.active = payload;
    },
    [MapMutationCodes.SET_BOTTOM_DRAWER_TITLE](state, payload) {
        state.bottomDrawer.title = payload;
    },
    [MapMutationCodes.SELECT_BASEMAP](state, payload) {
        const currentBasemap = state.basemaps.find((layer) => layer.get('basemap') && layer.getVisible());
        if (currentBasemap !== undefined) {
            currentBasemap.setVisible(false);
        }
        payload.setVisible(true);
    },
    [MapMutationCodes.SET_MAP_OBJECT](state, payload) {
        state.ol.view = initView();
        state.ol.home.center = state.ol.view.getCenter();
        state.ol.home.zoom = state.ol.view.getZoom();
        state.ol.map = initMap('map', state.ol.view, payload);
    },
    [MapMutationCodes.UPDATE_MAP_TARGET](state, payload) {
        state.ol.map?.setTarget('');
        state.ol.map?.setTarget(payload);
        state.ol.map?.updateSize();
    },
};
